export default __webpack_public_path__ + "static/media/blog01.c1c98e2a.jpg";